import { Loader } from '@/components/custom/loader';
import { EmptyState } from '@/components/custom/empty-state';
import { Card } from '@/components/ui/card';

/* ─── shared table primitives ────────────────────────────────── */
function SectionHeading({ children }) {
  return <h2 className="mb-3 text-sm font-bold uppercase tracking-wide text-neutral">{children}</h2>;
}

function SummaryTable({ head, rows, emptyLabel = 'Sem dados' }) {
  if (!rows || rows.length === 0) {
    return (
      <EmptyState
        variant="plain"
        type="data"
        text={emptyLabel}
      />
    );
  }
  return (
    <div className="round-dg-wrapper">
      <table
        className="round-dg round-dg--light"
        style={{ borderSpacing: '0 10px' }}
      >
        <thead className="round-dg__header">
          <tr className="round-dg__row">
            {head.map((h, i) => (
              <th
                key={i}
                className={['round-dg__cell-header round-dg__cell-header--sm', h.numeric ? 'text-right tabular-nums' : ''].join(' ')}
              >
                {h.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="round-dg__body">
          {rows.map((row, ri) => (
            <tr
              key={ri}
              className="round-dg__row"
            >
              {row.map((cell, ci) => (
                <td
                  key={ci}
                  className={['round-dg__cell round-dg__cell--sm', head[ci]?.numeric ? 'text-right tabular-nums' : ''].join(' ')}
                >
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

/* ─── main component ─────────────────────────────────────────── */
// summary is fetched and polled by the parent (Detail/index.jsx) so the top
// KPI card also updates live. OverviewTab just renders from the prop.
export default function OverviewTab({ summary }) {
  if (!summary) return <Loader />;

  const regionalRows = summary.by_regional.map(r => [r.regional_name, r.count]);

  const institutionRows = summary.by_regional.flatMap(r => r.by_institution.map(i => [r.regional_name, i.institution_name, i.count]));

  return (
    <div className="grid grid-cols-1 gap-5 pt-4 md:grid-cols-2">
      {/* ── Por Regional ── */}
      <Card className="p-5">
        <SectionHeading>Por Regional</SectionHeading>
        <SummaryTable
          head={[{ label: 'Regional' }, { label: 'Total', numeric: true }]}
          rows={regionalRows}
          emptyLabel="Nenhuma regional com inscrições"
        />
      </Card>

      {/* ── Por Unidade de Ensino ── */}
      <Card className="p-5">
        <SectionHeading>Por Unidade de Ensino</SectionHeading>
        <SummaryTable
          head={[{ label: 'Regional' }, { label: 'Unidade de Ensino' }, { label: 'Total', numeric: true }]}
          rows={institutionRows}
          emptyLabel="Nenhuma unidade com inscrições"
        />
      </Card>
    </div>
  );
}
